import useCheckUserPermission from './useCheckUserPermission';

export default useCheckUserPermission;
